<template>
    <ol-vector-layer :zIndex="5" v-if="layer.visible" :projection="layer?.projection" :name="layer.id" :title="layer.id"
        :properties="layerProperties">

        <ol-source-vector v-if="data && format" :format="GeoJSONformat" :features="data.features">
            <ol-style :overrideStyleFunction="overrideStyleFunction">
                <ol-style-text text="asdasdas"></ol-style-text>
            </ol-style>
        </ol-source-vector>
    </ol-vector-layer>

</template>



<script setup>
import { ref, inject, onMounted } from 'vue'
import { Circle, Fill, Stroke, Style, Text } from 'ol/style.js';


import GeoJSON from 'ol/format/GeoJSON.js'

const layer = defineModel("layer")


const format = inject("ol-format")


const GeoJSONformat = new format.GeoJSON()

const data = ref(null)



const layerProperties = () => {
    // console.log(layer.value.properties)
    return layer.value?.properties || {}
}

const readFeatures = () => {
    let crs = "EPSG:4326"

    if (data.value?.crs) {
        if (data.value.crs?.type === "name")
        crs = data.value.crs.properties.name
    }
    if (data.value?.crs) {
        if (data.value.crs?.type === "EPSG")
        crs = "EPSG:" + data.value.crs?.properties?.code
    }
    // console.log("crs: " + crs)


    data.value.features = new GeoJSON().readFeatures(data.value, {
        dataProjection: crs,   // 4326 is geojson default/standard
        featureProjection: "EPSG:3857",   // that should be view(map) projection
    })
}

const getData = async () => {

    const jsondata = JSON.parse(localStorage.stambecchiPreviousMonth)

    // const response = await fetch(layer.value.url)
    // const jsondata = await response.json()
    return jsondata
}


const readData = async () => {
    

    data.value = await getData()

    readFeatures()
}



onMounted(() => {

    setTimeout(() => { readData() }, 100)

})


/* startingStyle

startingStyle can be found in:

property style of geojson

           "strokeColor": "#555555FF",  // usare notazione rgba  
           "strokeWidth": 2,
           "fillColor": "#555555FF",  // usare notazione rgba  

           "defaultText": "txtdesc",   // da vedere se e come implementare (serve per le aquile, ex)
           "markerSize": "medium",   // da vedere se e come implementare (serve per le aquile, ex)
           "markerSymbol": "bus",   // da vedere se e come implementare (serve per le aquile, ex)
           "markerColor": "#fff",   // da vedere se e come implementare (serve per le aquile, ex)
*/




const overrideStyleFunction = (feature, style) => {
    // console.log("layer")
    // console.log(layer.value)
    // console.log("sourceOLVector")
    // console.log(sourceOLVector.value.source)
    // console.log(sourceOLVector.value.source.getProperties())

    let the_style = null

    if (data.value?.properties?.style){
    // is style a string
        if (typeof data.value?.properties?.style === 'string') {
            the_style = styles[data.value.properties.style]
        }
        // is style an object
        if (typeof data.value?.properties?.style === 'object') {
            the_style = data.value.properties.style
        }
    }
    else {
        the_style = styles.default
    }

    const strokeWidth = the_style?.strokeWidth || styles.default.strokeWidth
    const strokeColor = the_style?.strokeColor || styles.default.strokeColor
    const radius = the_style?.radius || styles.default.radius

    let fillColor = the_style?.fillColor || styles.default.fillColor

    // console.log(feature)
    // const geometry = feature.getGeometry()
    // console.log(geometry)
    const geometry_type = feature.getGeometry().getType()
    // console.log(geometry_type)
    let stroke = null

    if (feature?.get('timestamp')){    
        const the_date = new Date(feature?.get('timestamp'))
        const oggi = new Date()
        const meseCorrente = oggi.getMonth() // Restituisce 0 (Gennaio) a 11 (Dicembre)
        const mesePrecedente = oggi.getMonth()-1 
        const theDateMonth = the_date.getMonth()
        // console.log("======")
        // console.log(meseCorrente)
        // console.log(mesePrecedente)
        // console.log(mesePrecedente)
        if (meseCorrente == theDateMonth){
            
            fillColor = "#DD3322"

            stroke = new Stroke({
                // color: "#ebba34",
                color: strokeColor,
                width: strokeWidth,
                // lineDash: [2, 6        ]
            });
        }
        if (mesePrecedente == theDateMonth){
            
            fillColor = "#442211"

            stroke = new Stroke({
                color: strokeColor,
                width: strokeWidth,
            });
        }
        // console.log(fillColor)
    }

    const new_style = [];

    const fill = new Fill({
        color: fillColor,
    });


    if ([
        // "Point",
        "MultiPoint",
        "LineString",
        "MultiLineString",
        "Polygon",
        "MultiPolygon",
    ].includes(geometry_type)) {
        
        new_style.push(

            new Style({
                fill: fill,
                stroke: stroke,
            })
        )
    }


    if ([
        "Point",
    ].includes(geometry_type)) {

        const pStyleObj = {
            }

        if (the_style?.radius > 0) {
            pStyleObj.image = new Circle({
                fill: fill,
                stroke: stroke,
                radius: radius,
            })
        }

        new_style.push( new Style(pStyleObj) )
    }

    //from extra data in properties of the feature
    let title = ""

    if (the_style?.text?.overrideTitleMap){
        title = the_style.text?.overrideTitleMap
    }

    // if (title) {

    //     const text = new Text({
    //         font: the_style?.text?.font || '30px sans-serif',
    //         textAlign: the_style?.text?.textAlign || 'center',
    //         textBaseline: the_style?.text?.textBaseline || 'middle',
    //         text: title,
    //         padding: the_style?.text?.padding || [1, 2, 1, 5],
    //         backgroundFill: new Fill({
    //             color: the_style?.text?.backgroundFillColor || 'rgba(255,255,255,0.5)'
    //         }),
    //     })

    //     new_style[0].setText(text)
    // }

    // console.log(style)
    return new_style


}



const styles = {
    default: {
        strokeWidth: 3,
        strokeColor: "#0099ff",
        fillColor: "transparent",
        radius: 18,
    },
    ibex_previous_month:  {
        strokeWidth: 3,
        strokeColor: "#ffffff",
        fillColor: "#442211",
        radius: 10,
        text: {
            overrideTitleMap: "",
            font: '50px sans-serif',
            backgroundFillColor: 'transparent',
        },  
    },
}


</script>
